module.exports = __webpack_public_path__ + "img/connection-icon.e8edf1c9.svg";